<template>
  <div class="kpi-modal">
    <div ref="kpiEditModal" class="modal fade" data-bs-backdrop="static" id="kpiEditModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div class="modal-content bg-primary">
          <div class="modal-header">
            <div class="h5 modal-title text-light">
              {{ $t("views.kpi.structure.updateKPI") }}
              <DocsInfoLink color="light" target="createKPI"></DocsInfoLink>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body bg-light">
            <div v-if="elementType === 'kpi'" class="form-kpi">
              <div v-if="mode === 'add'" class="form-link">
                <div class="row mb-3">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input v-model="form.kpi.folder.content" type="checkbox" role="switch" id="kpiFolderCheck" class="form-check-input" :checked="form.kpi.folder.content">
                      <label for="kpiFolderCheck" class="form-check-label">{{ $t("views.kpi.edit.folder") }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label for="kpiParent" class="form-label">{{ $t("views.kpi.edit.parentKPI") }}</label>
                  <select v-model="form.kpi.parentId.content" class="form-select" id="kpiParent">
                    <option value="" :disabled="!isAdmin">{{ $t("views.kpi.edit.noParentKPI") }}</option>
                    <option v-for="kpi in kpisList" :key="kpi.id" :value="kpi.id" :disabled="mode === 'update' && kpi.id === selectedKPI.id ? true : false">
                      {{ kpi.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label for="kpiName" class="form-label">{{ $t("views.kpi.edit.name") }}<span class="text-danger">*</span></label>
                  <div v-if="form.kpi.folder.content">
                    <input v-model="form.kpi.name.content" id="kpiName" :class="form.kpi.name.error === '' ? 'form-control' : 'form-control is-invalid'">
                    <div class="invalid-feedback">{{ form.kpi.name.error }}</div>
                  </div>
                  <div v-if="!form.kpi.folder.content">
                    <input v-model="form.kpi.name.content" id="kpiName" :class="form.kpi.name.error === '' ? 'form-control' : 'form-control is-invalid'">
                    <div class="invalid-feedback">{{ form.kpi.name.error }}</div>
                  </div>
                </div>
              </div>
              <div v-if="!form.kpi.folder.content" class="row mb-3">
                <div class="col">
                  <label for="kpiResponsible" class="form-label">{{ $t("views.kpi.edit.responsible") }}</label>
                  <select v-model="form.kpi.responsible.content" id="kpiResponsible" :class="form.kpi.responsible.error === '' ? 'form-select' : 'form-select is-invalid'">
                    <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                      {{ employee.lastName }}, {{ employee.firstName }}
                    </option>
                  </select>
                  <div class="invalid-feedback">{{ form.kpi.responsible.error }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label for="kpiDescription" class="form-label">{{ $t("views.kpi.edit.description") }}</label>
                  <RTEditor ref="kpiDescription" v-model="form.kpi.description.content" contentType="html" id="kpiDescription"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.kpi.description.error }}</div>
                </div>
              </div>
              <div v-if="!form.kpi.folder.content">
                <div class="row mb-3">
                  <div class="col">
                    <label for="kpiTimeDimInput" class="form-label">{{ $t("views.kpi.edit.timeDimInput") }}<span class="text-danger">*</span></label>
                    <select v-model="form.kpi.timeDimInput.content" class="form-select" id="kpiTimeDimInput" :disabled="isFormulaActive" :class="form.kpi.timeDimInput.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <option value="M">{{ $t("general.month") }}</option>
                      <option value="Q">{{ $t("general.quarter") }}</option>
                      <option value="Y">{{ $t("general.year") }}</option>
                    </select>
                    <div class="invalid-feedback">{{ form.kpi.timeDimInput.error }}</div>
                  </div>
                  <div class="col">
                    <label for="kpiTimeDimDisplay" class="form-label">{{ $t("views.kpi.edit.timeDimDisplay") }}<span class="text-danger">*</span></label>
                    <select v-model="form.kpi.timeDimDisplay.content" class="form-select" id="kpiTimeDimDisplay" :disabled="isFormulaActive" :class="form.kpi.timeDimDisplay.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <option value="M">{{ $t("general.month") }}</option>
                      <option value="Q">{{ $t("general.quarter") }}</option>
                      <option value="Y">{{ $t("general.year") }}</option>
                    </select>
                    <div class="invalid-feedback">{{ form.kpi.timeDimDisplay.error }}</div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <label for="kpiUnit" class="form-label">{{ $t("views.kpi.edit.unit") }}<span class="text-danger">*</span></label>
                    <select v-model="form.kpi.unit.content" class="form-select" id="kpiUnit" :class="form.kpi.unit.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <option value="+" class="bg-custom-blue">{{ $t("views.kpi.edit.addUnit") }} </option>
                      <option v-for="unit in kpiUnits" :key="unit.id" :value="unit">
                        {{ unit }}
                      </option>
                    </select>
                    <div class="invalid-feedback">{{ form.kpi.unit.error }}</div>
                    <div v-if="addUnit">
                      <input v-model="form.kpi.newUnit.content" type="text" id="kpiNewUnit" :class="form.kpi.newUnit.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <div class="invalid-feedback">{{ form.kpi.newUnit.error }}</div>
                    </div>
                  </div>
                  <div class="col">
                    <label for="kpiDecimals" class="form-label">{{ $t("views.kpi.edit.decimals") }}</label>
                    <select v-model="form.kpi.decimals.content" class="form-select" id="kpiDecimals" :class="form.kpi.decimals.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <option value="0">0</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                    </select>
                    <div class="invalid-feedback">{{ form.kpi.decimals.error }}</div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <label for="kpiAggregation" class="form-label">{{ $t("views.kpi.edit.aggregation") }}<span class="text-danger">*</span></label>
                    <select v-model="form.kpi.aggregation.content" class="form-select" id="kpiAggregation" :class="form.kpi.aggregation.error === '' ? ' form-control' : 'form-control is-invalid'">
                      <option value="S">{{ $t("views.kpi.edit.sum") }}</option>
                      <option value="M">{{ $t("views.kpi.edit.mean") }}</option>
                      <option value="A">{{ $t("views.kpi.edit.ultimate") }}</option>
                    </select>
                    <div class="invalid-feedback">{{ form.kpi.aggregation.error }}</div>
                  </div>
                  <div class="col">
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <label for="kpiStatusYellow" class="form-label">
                      {{ $t("views.kpi.edit.status") }}
                      <svg class="bi mb-1" width="16" height="16" fill="currentColor">
                        <use class="text-success" xlink:href="@/assets/icons/icons.svg#circle-fill"/>
                      </svg>
                      /
                      <svg class="bi mb-1" width="16" height="16" fill="currentColor">
                        <use class="text-danger" xlink:href="@/assets/icons/icons.svg#circle-fill"/>
                      </svg>
                    </label>
                    <select v-model="form.kpi.rating.content" class="form-select" id="kpiRating">
                      <option value="H">{{ $t("views.kpi.edit.rating.H") }}</option>
                      <option value="L">{{ $t("views.kpi.edit.rating.L") }}</option>
                      <option value="N">{{ $t("views.kpi.edit.rating.N") }}</option>
                    </select>
                  </div>
                  <div class="col">
                    <label for="kpiStatusYellow" class="form-label">
                      {{ $t("views.kpi.edit.status") }}
                      <svg class="bi mb-1" width="16" height="16" fill="currentColor">
                        <use class="text-warning" xlink:href="@/assets/icons/icons.svg#circle-fill"/>
                      </svg>
                      {{ $t("views.kpi.edit.at") }}
                    </label>
                    <input v-model="form.kpi.statusYellow.content" type="text" id="kpiStatusYellow" @blur="focusOut(form.kpi.statusYellow.content)" :class="form.kpi.statusYellow.error === '' ? ' form-control' : 'form-control is-invalid'" :placeholder='$t("general.placeholderNone")'>
                    <div class="invalid-feedback">{{ form.kpi.statusYellow.error }}</div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <div class="form-check form-switch">
                      <input @change="toggleKPIValidCheck(!validCheck)" type="checkbox" role="switch" id="kpiValidCheck" class="form-check-input" :checked="validCheck">
                      <label for="kpiValidCheck" class="form-check-label">{{ $t("views.kpi.edit.validCheck") }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="validCheck" class="row mb-3">
                  <div class="col-6">
                    <label for="kpiValidFrom" class="form-label">{{ $t("views.kpi.edit.validFrom") }}</label>
                    <input v-model="form.kpi.validFrom.content" type="date" id="kpiValidFrom" :class="form.kpi.validFrom.error === '' ? 'form-control' : 'form-control is-invalid'">
                    <div class="invalid-feedback">{{ form.kpi.validFrom.error }}</div>
                  </div>
                  <div class="col-6">
                    <label for="kpiValidTo" class="form-label">{{ $t("views.kpi.edit.validTo") }}</label>
                    <input v-model="form.kpi.validTo.content" type="date" id="kpiValidTo" :class="form.kpi.validTo.error === '' ? 'form-control' : 'form-control is-invalid'">
                    <div class="invalid-feedback">{{ form.kpi.validTo.error }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="elementType === 'formula'" class="form-kpi-formula">
              <div class="row mb-3">
                <div class="col">
                  <label for="formulaValidFrom" class="form-label">{{ $t("views.kpi.edit.validFrom") }}<span class="text-danger">*</span></label>
                  <select v-model="form.formula.validFrom.content" :class="form.formula.validFrom.error === '' ? 'form-select' : 'form-select is-invalid'" id="formulaValidFrom">
                    <option v-for="(n, i) in 85" :key="'formulaValidFrom' + i" :value="(2015 + i)">{{ 2015 + i }}</option>
                  </select>
                  <div class="invalid-feedback">{{ form.formula.validFrom.error }}</div>
                </div>
                <div class="col">
                  <label for="formulaValidTo" class="form-label">{{ $t("views.kpi.edit.validTo") }}<span class="text-danger">*</span></label>
                  <select v-model="form.formula.validTo.content" :class="form.formula.validTo.error === '' ? 'form-select' : 'form-select is-invalid'" id="formulaValidTo">
                    <option v-for="(n, i) in 85" :key="'formulaValidTo' + i" :value="(2015 + i)">{{ 2015 + i }}</option>
                  </select>
                  <div class="invalid-feedback">{{ form.formula.validTo.error }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label for="formulaFormula" class="form-label">{{ $t("views.kpi.edit.formula") }}<span class="text-danger">*</span></label>
                  <div class="row mb-2">
                    <div class="col-6">
                      <select @change="addToFormula('kpi', $event)" class="form-select form-select-sm">
                        <option id="selectOptionFormulaKPIDefault" selected="selected" disabled>{{ $t("views.kpi.edit.insertKPI") }}</option>
                        <option v-for="kpi in kpisList" :key="'formulaKPI' + kpi.id" :value="kpi.id" :disabled="kpi.folder || kpi.id === selectedKPI.id ? true : false">{{ kpi.name }}</option>
                      </select>
                    </div>
                    <div class="col-6">
                      <select @change="addToFormula('operation', $event)" class="form-select form-select-sm">
                        <option id="selectOptionFormulaOperationDefault" selected disabled>{{ $t("views.kpi.edit.insertOperation") }}</option>
                        <option v-for="(operation, index) in formulaOperations" :key="'formulaOperation' + index" :value="operation">{{ operation }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col-8">
                      <div class="input-group input-group-sm">
                        <input v-model="formulaNumberInput" v-on:keyup.enter="addToFormula('number', false)" type="number" class="form-control" placeholder="Zahlenwert einfügen">
                        <button @click="addToFormula('number', false)" class="btn btn-outline-secondary" type="button">{{ $t("views.kpi.edit.insert") }}</button>
                      </div>
                    </div>
                  </div>
                  <div id="input-formula" class="p-2 mb-2" :class="form.formula.formula.error === '' ? '' : 'is-invalid'">
                    <span v-if="!form.formula.formula.content.length" class="text-muted">{{ $t("views.kpi.edit.helpFormula") }}</span>
                    <span v-for="(element, index) in form.formula.formula.content" :key="'formulaElement' + index" class="badge fw-normal me-2 mb-2" :class="element.elementType === 'kpi' ? 'text-bg-primary text-light' : 'text-bg-secondary'">{{ element.name }}</span>
                  </div>
                  <div class="invalid-feedback mb-2">{{ form.formula.formula.error }}</div>
                  <button @click="deleteFormula()" class="btn btn-sm btn-outline-secondary" type="button">{{ $t("views.kpi.edit.resetFormula") }}</button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-light justify-content-between">
            <div>
              <button v-if="mode === 'update'" @click="updateModalMode()" type="button" class="btn btn-sm btn-outline-danger" :class="selectedKPI.hasNodes || this.elementType === 'formula' ? 'disabled' : ''" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#kpiDeleteModal">{{ $t("general.delete") }}</button>
            </div>
            <div>
              <button type="button" class="btn btn-sm btn-outline-secondary me-2" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
              <button @click="save()" type="button" class="btn btn-sm btn-primary">{{ $t("general.save") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocsInfoLink from '../../components/DocsInfoLink.vue'
import RTEditor from '../RTEditor.vue'
import { Modal } from 'bootstrap'
import { ref } from 'vue'
import initializeForm from '../../composables/initializeForm'
import setFormContent from '../../composables/setFormContent'
import * as validation from '../../composables/validation'
import * as formatUtils from '../../composables/formatUtils'

export default {
  name: 'KPIEditModal',
  mounted () {
    const myModalDialog = document.getElementById('kpiEditModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      const mode = this.$parent.kpiModalMode
      if (mode === 'add') {
        initializeForm(this.form.kpi)
        initializeForm(this.form.formula)
        this.form.kpi.parentId.content = this.$store.state.selectedKPI.id
        this.form.kpi.rating.content = 'H'
        this.form.kpi.decimals.content = '0'
      }
      this.form.kpi.newUnit.content = ''
    })
    myModalDialog.addEventListener('hidden.bs.modal', event => {
      const mode = this.$parent.kpiModalMode
      if (mode !== 'add' && mode !== 'delete') {
        if (this.elementType === 'kpi') setFormContent(this.form, this.$store.state.selectedKPI, 'kpi', this.elementType, this.$parent.kpiModalElementId)
        if (this.elementType === 'formula') setFormContent(this.form, this.$store.state.selectedKPI, 'kpi', this.elementType, this.$parent.kpiModalElementId)
      }
    })
  },
  data () {
    return {
      form: {
        kpi: {
          folder: {
            content: '',
            error: '',
            validate: []
          },
          parentId: {
            content: '',
            error: '',
            validate: []
          },
          name: {
            content: '',
            error: '',
            maxLength: 255,
            validate: ['empty', 'length']
          },
          description: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'kpiDescription'
          },
          responsible: {
            content: '',
            error: '',
            validate: []
          },
          timeDimInput: {
            content: '',
            error: '',
            validate: ['empty']
          },
          timeDimDisplay: {
            content: '',
            error: '',
            validate: ['empty']
          },
          unit: {
            content: '',
            error: '',
            validate: ['empty']
          },
          newUnit: {
            content: '',
            error: '',
            validate: []
          },
          decimals: {
            content: '',
            error: '',
            validate: []
          },
          rating: {
            content: '',
            error: '',
            validate: []
          },
          aggregation: {
            content: '',
            error: '',
            validate: ['empty']
          },
          statusYellow: {
            content: '',
            error: '',
            validate: []
          },
          validFrom: {
            content: '',
            error: '',
            validate: ['validFrom']
          },
          validTo: {
            content: '',
            error: '',
            validate: ['validTo']
          }
        },
        formula: {
          validFrom: {
            content: '',
            error: '',
            validate: ['empty']
          },
          validTo: {
            content: '',
            error: '',
            validate: ['empty']
          },
          formula: {
            content: '',
            error: '',
            validate: ['empty']
          }
        }
      },
      formulaOperations: ['(', ')', '+', '-', '*', '/'],
      formulaNumberInput: '',
      selectedElement: ''
    }
  },
  components: {
    DocsInfoLink,
    RTEditor
  },
  computed: {
    elementId () {
      return this.$parent.kpiModalElementId
    },
    elementType () {
      return this.$parent.kpiModalElementType
    },
    mode () {
      return this.$parent.kpiModalMode
    },
    kpis () {
      return this.$store.state.kpis
    },
    kpiUnits () {
      return this.$store.state.kpiUnits
    },
    kpisList () {
      return this.$store.state.kpisList
    },
    employees () {
      return this.$store.state.employees
    },
    selectedKPI () {
      return this.$store.state.selectedKPI
    },
    validCheck () {
      if (this.form.kpi.validFrom.content) {
        return true
      }
      return false
    },
    addUnit () {
      if (this.form.kpi.unit.content === '+') {
        return true
      } else {
        return false
      }
    },
    isFormulaActive () {
      if (this.mode === 'add') {
        return false
      }
      if (this.selectedKPI.formulas?.length) {
        let isActive = false
        this.selectedKPI.formulas.forEach(formula => {
          const curYear = new Date().getFullYear()
          if (formula.validFrom <= curYear && formula.validTo >= curYear) {
            isActive = true
          }
        })
        return isActive
      } else {
        return false
      }
    },
    isAdmin () {
      return this.$store.state.user.role === 10387
    }
  },

  methods: {
    focusOut: function (number) {
      const formattedNumber = this.formatInputNumber(number)
      this.form.kpi.statusYellow.content = formattedNumber
    },
    async save () {
      this.$store.commit('SET_LOADING_STATUS', true)

      let valid = 0
      if (this.elementType === 'kpi') {
        if (this.form.kpi.unit.content === '+') this.form.kpi.newUnit.validate[0] = 'empty'
        else {
          this.form.kpi.newUnit.validate = []
          this.form.kpi.newUnit.content = ''
        }
      }
      if (this.elementType === 'formula') valid = validation.fieldValidation(this.form.formula)

      if (valid === 0) {
        let elementData = {}
        let dispatchFunc = ''

        Object.keys(this.form[this.elementType]).forEach(field => {
          if (this.form[this.elementType][field].rtEditor) {
            const ref = this.form[this.elementType][field].ref
            if (this.$refs[ref]) {
              this.form[this.elementType][field].content = this.$refs[ref].getContent()
            }
          }
        })

        if (this.form.kpi.unit.content === '+') {
          this.form.kpi.unit.content = this.form.kpi.newUnit.content
        }
        if (this.elementType !== 'kpi') {
          elementData = {
            element: {
              id: this.elementId,
              validFrom: this.form.formula.validFrom.content,
              validTo: this.form.formula.validTo.content,
              formula: this.form.formula.formula.content
            }
          }
          elementData.elementType = (this.elementType + 's')
          elementData.kpiId = this.selectedKPI.id
        } else {
          elementData = Object.assign(
            ...Object.entries(this.form[this.elementType]).map(([key, value]) => ({ [key]: value.content }))
          )
          elementData.id = this.elementId
          if (elementData.parentId === undefined) elementData.parentId = ''
          if (elementData.responsible === undefined) elementData.responsible = ''
          if (elementData.unit_name === undefined) elementData.unit_name = elementData.unit
          if (elementData.unit_decimals === undefined) elementData.unit_decimals = elementData.decimals
        }

        dispatchFunc = this.elementType === 'kpi' ? (this.mode + 'KPI') : (this.mode + 'KPIElement')
        await this.$store.dispatch(dispatchFunc, elementData).then(() => {
          this.closeModal()
          Object.keys(this.form[this.elementType]).forEach(field => {
            if (this.mode === 'add') {
              if (field === 'folder') {
                this.form[this.elementType][field].content = false
              } else {
                this.form[this.elementType][field].content = ''
              }
            }
            this.form[this.elementType][field].error = ''
          })
        })
      }

      this.$parent.kpiKeyInt++

      this.$store.commit('SET_LOADING_STATUS', false)
      if (this.mode === 'add') {
        await this.$store.dispatch('getKPIs', { validFrom: this.$parent.filterValidFrom, validTo: this.$parent.filterValidTo })
      }
    },

    toggleKPIValidCheck (validCheck) {
      if (validCheck) {
        if (this.mode === 'update' && this.selectedKPI.validFrom && this.selectedKPI.validTo) {
          [this.form.kpi.validFrom.content, this.form.kpi.validTo.content] = [this.selectedKPI.validFrom, this.selectedKPI.validTo]
        } else {
          this.form.kpi.validFrom.content = '2000-01-01'
          this.form.kpi.validTo.content = '2099-12-31'
        }
      } else {
        this.form.kpi.validFrom.content = this.form.kpi.validTo.content = ''
      }
    },
    statusRed () {
      // const inputRed = this.form.kpi.statusRed.content
      // if (inputRed === 100) {
      //   this.form.kpi.statusRed.content = 99
      //   return ['<', 99]
      // } else if (inputRed < 100) {
      //   return ['<', inputRed]
      // } else if (inputRed > 100) {
      //   return ['>', inputRed]
      // } else {
      //   return ['<', 0]
      // }
    },
    statusYellow () {
      const inputYellow = this.form.kpi.statusYellow.content
      // if (inputRed < 100) {
      //   if (inputYellow > inputRed) {
      //     return ['<', inputYellow]
      //   } else {
      //     this.form.kpi.statusYellow.content = inputRed + 1
      //     return ['<', inputRed + 1]
      //   }
      // } else if (inputRed > 100) {
      //   if (inputYellow < inputRed) {
      //     return ['>', inputYellow]
      //   } else {
      //     this.form.kpi.statusYellow.content = inputRed - 1
      //     return ['>', inputRed - 1]
      //   }
      // } else {
      //   return ['<', 0]
      // }
      return inputYellow
    },
    updateModalContent () {
      Object.keys(this.form[this.elementType]).forEach(field => {
        let selectedElement = this.selectedKPI
        if (this.elementType !== 'kpi') {
          const elementTypePlural = this.elementType + 's'
          selectedElement = this.selectedKPI[elementTypePlural].find(element => {
            return element.id === this.$parent.kpiModalElementId
          })
          this.$parent.selectedElement = selectedElement
        }
        if (field in selectedElement) {
          if (field === 'responsible' && selectedElement[field].id) {
            this.form[this.elementType].responsible.content = selectedElement[field].id
          } else {
            this.form[this.elementType][field].content = selectedElement[field]
          }
          this.form[this.elementType][field].error = ''
        }
      })
    },
    updateModalMode () {
      if (this.elementType === 'kpi') {
        this.$parent.kpiModalMode = 'delete'
      }
    },
    addToFormula (elementType, event) {
      let element = {}
      if (!Array.isArray(this.form.formula.formula.content)) {
        this.form.formula.formula.content = []
      }
      if (elementType === 'kpi') {
        if (!this.form.formula.formula.content.length || this.form.formula.formula.content.at(-1).elementType === 'operation') {
          element = this.kpisList.find(kpi => {
            return kpi.id === event.target.value
          })
          const elementName = element.name.replace(/- /gm, '').trim()

          this.form.formula.formula.content.push({ id: element.id, name: elementName, elementType })
        }
        document.getElementById('selectOptionFormulaKPIDefault').selected = true
      } else if (elementType === 'operation') {
        element = { id: ('operation' + this.form.formula.formula.content.length), name: event.target.value }
        this.form.formula.formula.content.push({ id: element.id, name: element.name, elementType })
        document.getElementById('selectOptionFormulaOperationDefault').selected = true
      } else if (elementType === 'number') {
        if (this.formulaNumberInput !== '' && (!this.form.formula.formula.content.length || this.form.formula.formula.content.at(-1).elementType === 'operation')) {
          element = { id: ('number' + this.form.formula.formula.content.length), name: this.formulaNumberInput }
          this.form.formula.formula.content.push({ id: element.id, name: element.name, elementType })
          this.formulaNumberInput = ''
        }
      }
    },
    deleteFormula () {
      this.form.formula.formula.content = ''
    },
    checkFormula () {
      this.form.formula.formula.content = this.form.formula.formula.content.replace(/[^+\-*/]/gm, '')
    },
    formatNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      const decimals = 2
      return formatUtils.formatNumber(userLocale, number, decimals)
    },
    formatInputNumber (number) {
      const userLocale = this.$store.state.user.settings?.language
      const decimals = 2
      return formatUtils.formatInputNumber(userLocale, number, decimals)
    },
    timeDimValidCheck (formObject) {
      return validation.timeDimValidation(formObject)
    }
  },
  watch: {
    elementId () {
      this.updateModalContent()
    },
    mode (newMode) {
      this.employeesExistingCheck = false
      if (newMode === 'add') {
        Object.keys(this.form[this.elementType]).forEach(field => {
          if (field === 'folder') {
            this.form[this.elementType][field].content = false
          } else {
            this.form[this.elementType][field].content = this.form[this.elementType][field].error = ''
          }
        })
      } else if (newMode === 'update') {
        this.updateModalContent()
      }
    }
  },
  setup () {
    const kpiEditModal = ref(null)
    const closeModal = () => Modal.getInstance(kpiEditModal.value)?.hide()
    return { kpiEditModal, closeModal }
  }
}
</script>

<style scoped>
#input-formula {
  width: 100%;
  height: 160px;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  background-color: #fff;
  overflow-y: scroll;
}
</style>
